module.exports = __webpack_public_path__ + "img/pos-device.97355864.jpg";